export const TYPE_FORMATTED_MIXPANEL = {
  posts: 'Video',
  creators: 'Creator',
  topics: 'Topic',
  industry_topic: 'Industry Category',
  global_topic: 'Global Topic',
  subtopics: 'Subtopic',
  niches: 'Niche',
  savedPostSearches: 'Saved Search',
  trendings: 'Trending',
  tags: 'Tag',
}
